// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"ba38d735","55":"b4c6e811","321":"0d9229af","351":"06e4a13f","365":"e562636b","439":"a4718cce","858":"15885a2d","916":"52da09f8"}[chunkId] + ".chunk.js";
};